import { Component, Input, ViewContainerRef, OnDestroy, OnChanges } from '@angular/core';

import { CustomFilterTypeModel } from '../../models/custom-filter-type.model';
import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';

@Component({
    selector: 'agpr-custom-filter-wrapper',
    templateUrl: './custom-filter-wrapper.component.html',
    styleUrls: ['./custom-filter-wrapper.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: CustomFilterWrapperComponent
        }
    ],
    standalone: false
})
export class CustomFilterWrapperComponent extends AbstractFilterTypeComponent implements OnChanges, OnDestroy {
    @Input() declare filter: CustomFilterTypeModel;

    customFilterComponent: AbstractFilterTypeComponent;

    constructor(
        private viewContainer: ViewContainerRef
    ) {
        super();
    }

    ngOnChanges(): void {
        this.setFilter(this.filter);
    }
    ngOnDestroy(): void {
        this.viewContainer.clear();
    }

    private setFilter(filter: CustomFilterTypeModel) {
        this.viewContainer.clear();

        const componentRef = this.viewContainer.createComponent(filter.customComponent);
        this.customFilterComponent = componentRef.instance;
        this.customFilterComponent.filter = filter;
        this.customFilterComponent.style = this.style;
        this.customFilterComponent.id = this.id;
    }

    refresh() {
        this.customFilterComponent.refresh();
    }
}
